import { render } from "./InputDate.vue?vue&type=template&id=cc8f1670"
import script from "./InputDate.vue?vue&type=script&lang=ts"
export * from "./InputDate.vue?vue&type=script&lang=ts"
script.render = render

export default script